import { cn } from "@/lib/utils";

function TwitterIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={cn("", className)}
      style={{
        filter: "drop-shadow(0 0 2px var(--color-header-accent, #0A74FF))" // Accent glow
      }}
    >
      <path
        fill="#1a1a1a" // Always black fill for the X
        stroke="var(--color-header-accent, #0A74FF)" // Accent outline
        strokeWidth="0.5"
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
      />
    </svg>
  );
}

export function Footer({ className }: { className?: string }) {
  const handleNavigation = (path: string) => {
    // Use window.location for hard navigation to bypass any React Router issues
    window.location.href = path;
  };

  return (
    <footer className={`border-t border-[var(--color-header-accent,#0A74FF)] py-6 bg-background/50 backdrop-blur-sm relative z-50 ${className || ''}`}>
      <div className="container mx-auto px-4">
        <div className="text-center text-sm space-y-4">
          <div className="flex items-center justify-center gap-2">
            <a 
              href="https://x.com/intent/follow?screen_name=mobdaboss" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-3 px-3.5 py-2 border-2 border-[var(--color-header-accent,#0A74FF)] rounded-full relative overflow-hidden group transition-all duration-300 hover:-translate-y-0.5"
              style={{
                boxShadow: '0 0 18px var(--color-header-accent, #0A74FF)'
              }}
            >
              {/* Background gradient */}
              <span 
                className="absolute inset-0 opacity-15"
                style={{
                  background: 'var(--color-header-accent, #0A74FF)'
                }}
              />
              
              {/* Shimmer effect */}
              <span 
                className="absolute top-0 left-0 w-full h-full animate-shimmer"
                style={{
                  background: 'linear-gradient(90deg, transparent, var(--color-header-accent, #0A74FF), transparent)',
                  opacity: 0.15,
                  animation: 'shimmer 3s linear infinite'
                }}
              />
              
              {/* Text with gradient */}
              <span 
                className="relative z-10 font-bold"
                style={{
                  background: 'var(--color-header-accent, #0A74FF)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                Follow @MobDaBoss on
              </span>
              
              {/* X Badge */}
              <span 
                className="relative z-10 inline-flex items-center justify-center w-7 h-7 rounded-full border-2 border-[var(--color-header-accent,#0A74FF)]"
                style={{
                  background: 'var(--color-header-accent, #0A74FF)',
                  boxShadow: '0 4px 12px var(--color-header-accent, #0A74FF)'
                }}
              >
                <TwitterIcon className="w-4 h-4" />
              </span>
            </a>
          </div>
          
          {/* Navigation Links */}
          <div className="flex flex-wrap items-center justify-center gap-3 text-xs">
            <button 
              type="button"
              onClick={() => handleNavigation("/")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Home
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/account?tab=settings")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Account
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/account?tab=referrals")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Referrals Dashboard
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/account?tab=app-settings")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              App Settings
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/about")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              About
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/blog")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Blog
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/nft")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              NFT Mint
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/multisender")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Multisender
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/contact")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Contact
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/privacy-policy")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Privacy Policy
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/terms-of-service")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Terms of Service
            </button>
            <span className="text-muted-foreground">•</span>
            <button 
              type="button"
              onClick={() => handleNavigation("/refund-policy")}
              className="text-[var(--color-header-accent,#0A74FF)] hover:opacity-80 transition-colors bg-transparent border-0 cursor-pointer p-0"
            >
              Refund Policy
            </button>
          </div>
          
          <div className="container mx-auto px-2 sm:px-4 py-2 text-center">
            <p className="text-sm text-muted-foreground">
              &copy; 2025 mdbapp.io. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
